export var InsistenceStatus;
(function (InsistenceStatus) {
    InsistenceStatus["Pending"] = "pending";
    InsistenceStatus["Accepted"] = "accepted";
    InsistenceStatus["Rejected"] = "rejected";
})(InsistenceStatus || (InsistenceStatus = {}));
